import Alpine from "alpinejs";

export const alpineMagics = () => {
  Alpine.magic("removePaddingBeforeList", (el) => {
    const paragraphs = el.querySelectorAll(".para-p-sm p");

    paragraphs.forEach((p) => {
      if (p.nextElementSibling && p.nextElementSibling.tagName === "UL") {
        p.style.paddingBottom = "0";
      }
    });
  });
};
